import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Company } from '../../../models/company.model';
import { CompanyService } from '../../../services/company.service';
import { ComponentCommService } from '../../../services/component-comm.service';
import { CurrentDateService } from '../../../services/current-date.service';
import { startOfDay } from '../../../utilities/date';

@Component({
  selector: 'app-market-prices',
  templateUrl: './market-prices.component.html',
  styleUrls: ['./market-prices.component.scss']
})
export class MarketPricesComponent implements OnInit, OnDestroy {

  public company: Company;
  /** The language currently used. */
  public currentLang: string;
  public delivery_places: Array<any>;
  public editingData;
  public hoveredCompany;
  /** Flag used to indicate if the component is loading information. */
  public loading: boolean = true;
  public market_periods: Array<any> = [];
  public modalRef: BsModalRef;
  /**
   * Flag used to enable/disable UI buttons and links when an API request is in
   * progress.
   */
  public processing: boolean;
  public products: Array<any>;
  public tableMatrix;
  public type: string = 'zone';

  private inputCoord;
  private marketPrices;
  private subscriptions: Array<any> = [];
  // Assign company colors
  private c_colors: any = {};
  private currentColor: number = 0;
  private palette = [
    '#225f1e', // Dark green
    '#8732cd', // Purple
    '#e44436', // Red
    '#005888', // Blue
    '#ff9300', // Orange
    '#37aef3', // Light blue
    '#cd3292' // Pink
  ];

  // Demo data
  public data = {
    companies: [{ "id": 8, "is_new": false, "name": "jgvent-mx", "logo": null, "fiscal_id": { "type": "cuit", "value": "123123" }, "activity": { "id": 2, "name": "Acopiador / Consignatario" }, "verification_date": "2018-10-10 16:17:07", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 14, "is_new": false, "name": "Agronegocios", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5bec80eba540f\/504232_2018-11-14.jpeg", "fiscal_id": { "type": "cuit", "value": "123" }, "activity": { "id": 2, "name": "Acopiador / Consignatario" }, "verification_date": "2018-07-19 17:18:00", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 15, "is_new": false, "name": "Emilio Testing SRL", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5b510b3be929f\/642617_2018-07-19.png", "fiscal_id": { "type": "cuit", "value": "20288024082" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-07-26 21:48:37", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 17, "is_new": false, "name": "Compa\u00f1ia Alamos", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5b60ae8c06ddc\/279436_2018-07-31.jpeg", "fiscal_id": { "type": "cuit", "value": "\u02c6%\u02c6##ZX:\"\u02dc\u02dc\u02dc\u02dc\u02dc\u02dc" }, "activity": { "id": 2, "name": "Acopiador / Consignatario" }, "verification_date": "2018-07-31 18:46:37", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 18, "is_new": false, "name": "Corredor Flow", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/corr-02.png", "fiscal_id": { "type": "cuit", "value": "20257255566" }, "activity": { "id": 6, "name": "Corredor" }, "verification_date": "2018-07-31 20:00:42", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 19, "is_new": false, "name": "Test Corredor", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5b631563d24e7\/95076_2018-08-02.jpeg", "fiscal_id": { "type": "cuit", "value": "323231111" }, "activity": { "id": 6, "name": "Corredor" }, "verification_date": null, "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 20, "is_new": false, "name": "El Productor", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/prod-03.png", "fiscal_id": { "type": "cuit", "value": "20257255566" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2018-08-02 21:06:35", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 21, "is_new": false, "name": "DYNS-TECNOLOGY C.A.", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5b7c33881caae\/312750_2018-08-21.png", "fiscal_id": { "type": "cuit", "value": "1132470565" }, "activity": { "id": 5, "name": "Consumo / Industria" }, "verification_date": "2018-08-21 15:59:45", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 22, "is_new": false, "name": "El productor SA", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/prod-03.png", "fiscal_id": { "type": "cuit", "value": "11111111111" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2018-08-21 17:50:09", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 23, "is_new": false, "name": "MULTISERVICIOS JUAN", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5b7c6cd607734\/75877_2018-08-21.jpeg", "fiscal_id": { "type": "cuit", "value": "245676543456" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2018-08-21 19:50:20", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 24, "is_new": false, "name": "Exportadora J", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5b80477c222ae\/711785_2018-08-24.jpeg", "fiscal_id": { "type": "cuit", "value": "123321123" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-08-24 18:24:23", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 25, "is_new": false, "name": "Molino J", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5b80496377ecc\/485950_2018-08-24.jpeg", "fiscal_id": { "type": "cuit", "value": "3333333" }, "activity": { "id": 4, "name": "Molino" }, "verification_date": "2018-08-24 18:24:27", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 27, "is_new": false, "name": "test", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5ba0110a6a838\/725717_2018-09-17.jpeg", "fiscal_id": { "type": "cuit", "value": "123123" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-09-17 20:41:10", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 28, "is_new": false, "name": "Molino Del", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5ba012271944f\/473350_2018-09-17.jpeg", "fiscal_id": { "type": "cuit", "value": "123" }, "activity": { "id": 7, "name": "Productor / Consumo" }, "verification_date": "2018-09-17 20:44:59", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 29, "is_new": false, "name": "Exportador X", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5ba013860f816\/445341_2018-09-17.jpeg", "fiscal_id": { "type": "cuit", "value": "123" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-09-17 20:50:55", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 30, "is_new": false, "name": "JM_PRODUCTOR", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5ba7e7ccafa9c\/932832_2018-09-23.jpeg", "fiscal_id": { "type": "cuit", "value": "111111111" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2018-09-24 12:08:55", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 31, "is_new": false, "name": "JM_EXPORTADOR", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5ba7e897984ca\/372420_2018-09-23.png", "fiscal_id": { "type": "cuit", "value": "222222222" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-09-24 12:09:03", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 32, "is_new": false, "name": "JM_CORREDOR", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5ba7e8e1d04ae\/189606_2018-09-23.jpeg", "fiscal_id": { "type": "cuit", "value": "333333333" }, "activity": { "id": 6, "name": "Corredor" }, "verification_date": "2018-09-24 12:09:10", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 33, "is_new": false, "name": "JM_MOLINO", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5ba7ea03eba60\/621489_2018-09-23.jpeg", "fiscal_id": { "type": "cuit", "value": "444444444" }, "activity": { "id": 4, "name": "Molino" }, "verification_date": "2018-09-24 12:14:27", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 35, "is_new": false, "name": "EXPORTE_PRUEBA", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5bbe194407f61\/701387_2018-10-10.png", "fiscal_id": { "type": "cuit", "value": "99999999" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-10-10 15:24:25", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 36, "is_new": false, "name": "Catamarca SRL", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/moli-02.png", "fiscal_id": { "type": "cuit", "value": "239239843" }, "activity": { "id": 4, "name": "Molino" }, "verification_date": "2018-10-22 19:44:43", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 37, "is_new": false, "name": "Del Valle S.A.", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/prod-05.png", "fiscal_id": { "type": "cuit", "value": "30203003039" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2018-10-22 19:44:39", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 38, "is_new": false, "name": "Silos Norte", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/acop-05.png", "fiscal_id": { "type": "cuit", "value": "30203003039" }, "activity": { "id": 2, "name": "Acopiador / Consignatario" }, "verification_date": "2018-11-08 18:28:49", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 39, "is_new": false, "name": "EXPOR S.A.", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/prod-02.png", "fiscal_id": { "type": "cuit", "value": "30203003039" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2018-11-08 18:28:44", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 40, "is_new": false, "name": "Global Grain", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/expo-03.png", "fiscal_id": { "type": "cuit", "value": "321321321" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-11-16 20:11:05", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 44, "is_new": false, "name": "JM_EXPORTER_PARAGUAY", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5bf6ec1a40bab\/827250_2018-11-22.png", "fiscal_id": { "type": "cuit", "value": "12345678" }, "activity": { "id": 3, "name": "Exportador" }, "verification_date": "2018-11-22 17:49:28", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 45, "is_new": false, "name": "JM_CORREDOR_PARAGUAY", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5bf6ec7be4c56\/263400_2018-11-22.jpeg", "fiscal_id": { "type": "cuit", "value": "1234567831" }, "activity": { "id": 6, "name": "Corredor" }, "verification_date": "2018-11-22 17:51:08", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 46, "is_new": false, "name": "Cerro Porte\u00f1o", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/companies\/5bfed56d7fa35\/151666_2018-11-28.png", "fiscal_id": { "type": "cuit", "value": "30203003039" }, "activity": { "id": 15, "name": "Cooperative" }, "verification_date": "2018-11-22 17:51:08", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 59, "is_new": false, "name": "ArgenTrade", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/prod-05.png", "fiscal_id": { "type": "cuit", "value": "2222222222222" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2019-01-30 20:49:04", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 60, "is_new": false, "name": "Ag Soja", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/prod-05.png", "fiscal_id": { "type": "cuit", "value": "3333333333333" }, "activity": { "id": 1, "name": "Productor" }, "verification_date": "2019-01-30 20:49:04", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 61, "is_new": false, "name": "Food Corp.", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/prod-05.png", "fiscal_id": { "type": "cuit", "value": "4444444444" }, "activity": { "id": 7, "name": "Productor / Consumo" }, "verification_date": "2019-01-30 20:49:04", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 62, "is_new": false, "name": "MBP Hnos.", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/acop-05.png", "fiscal_id": { "type": "cuit", "value": "6666666666" }, "activity": { "id": 2, "name": "Acopiador / Consignatario" }, "verification_date": "2019-01-30 20:49:04", "approved": true, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }, { "id": 79, "is_new": false, "name": "arg-corredor-test1", "logo": "https:\/\/agreemarket-fas-dev.s3.us-east-2.amazonaws.com\/fas\/default-thumbs\/corr-05.png", "fiscal_id": { "type": "cuit", "value": "423423" }, "activity": { "id": 6, "name": "Corredor" }, "verification_date": "2019-05-17 18:06:36", "approved": false, "address": { "country": { "id": 10, "iso": "ar", "name": "Argentina" } } }],
    products: [{ "id": 1, "name": "Soja", "buyer": false, "seller": false, "attributes": { "harvest": { "enabled": true }, "quality": { "condition": { "name": "Condici\u00f3n", "empty": null, "order": 1, "abbrev": "Cond.", "status": 1, "values": [{ "id": 1, "name": "F\u00e1brica", "slug": "fabrica", "abbrev": "Fab.", "status": 1 }, { "id": 2, "name": "C\u00e1mara", "slug": "camara", "abbrev": "Cam.", "status": 1 }] } }, "order_quantity_label": { "venta": "Cantidad", "compra": "Cantidad" } }, "contract_clauses": null, "active": 1, "quantity_units": [{ "id": 1, "name": "Tonelada m\u00e9trica", "name_plural": "Tonelada(s)", "abbrev": "t", "slug": "t" }] }, { "id": 2, "name": "Ma\u00edz", "buyer": false, "seller": false, "attributes": { "harvest": { "enabled": true }, "quality": { "grade": { "name": "Grado", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 2, "abbrev": "GR", "status": 1, "values": [{ "id": 1, "name": "1", "slug": "1", "abbrev": "1", "status": 1 }, { "id": 2, "name": "2", "slug": "2", "abbrev": "2", "status": 1 }, { "id": 3, "name": "3", "slug": "3", "abbrev": "3", "status": 1 }] }, "condition": { "name": "Condici\u00f3n", "empty": null, "order": 1, "abbrev": "Cond.", "status": 1, "values": [{ "id": 1, "name": "C\u00e1mara", "slug": "camara", "abbrev": "Cam.", "status": 1 }] } }, "order_quantity_label": { "venta": "Cantidad", "compra": "Cantidad" } }, "contract_clauses": null, "active": 1, "quantity_units": [{ "id": 1, "name": "Tonelada m\u00e9trica", "name_plural": "Tonelada(s)", "abbrev": "t", "slug": "t" }] }, { "id": 3, "name": "Trigo Pan", "buyer": false, "seller": false, "attributes": { "harvest": { "enabled": true }, "quality": { "ph": { "name": "PH", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 2, "abbrev": "PH", "status": 1, "values": [{ "id": 1, "name": "M\u00ednimo 73", "slug": "73", "abbrev": "73", "status": 1 }, { "id": 2, "name": "M\u00ednimo 74", "slug": "74", "abbrev": "74", "status": 1 }, { "id": 3, "name": "M\u00ednimo 75", "slug": "75", "abbrev": "75", "status": 1 }, { "id": 4, "name": "M\u00ednimo 76", "slug": "76", "abbrev": "76", "status": 1 }, { "id": 5, "name": "M\u00ednimo 77", "slug": "77", "abbrev": "77", "status": 1 }, { "id": 6, "name": "M\u00ednimo 78", "slug": "78", "abbrev": "78", "status": 1 }] }, "grade": { "name": "Grado", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 5, "abbrev": "GR", "status": 1, "values": [{ "id": 1, "name": "1", "slug": "1", "abbrev": "1", "status": 1 }, { "id": 2, "name": "2", "slug": "2", "abbrev": "2", "status": 1 }, { "id": 3, "name": "3", "slug": "3", "abbrev": "3", "status": 1 }] }, "gluten": { "name": "Gluten", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 4, "abbrev": "GL", "status": 1, "values": [{ "id": 1, "name": "M\u00ednimo 20", "slug": "20", "abbrev": "20", "status": 1 }, { "id": 2, "name": "M\u00ednimo 22", "slug": "22", "abbrev": "22", "status": 1 }, { "id": 3, "name": "M\u00ednimo 24", "slug": "24", "abbrev": "24", "status": 1 }, { "id": 4, "name": "M\u00ednimo 26", "slug": "26", "abbrev": "26", "status": 1 }, { "id": 5, "name": "M\u00ednimo 28", "slug": "28", "abbrev": "28", "status": 1 }, { "id": 6, "name": "M\u00ednimo 30", "slug": "30", "abbrev": "30", "status": 1 }, { "id": 7, "name": "Minimum 32 o m\u00e1s", "slug": "32_mas", "abbrev": "32+", "status": 1 }, { "id": 8, "name": "Art\u00edculo 12", "slug": "art_12", "abbrev": "Art. 12", "status": 1 }] }, "protein": { "name": "Proteina", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 3, "abbrev": "PB", "status": 1, "values": [{ "id": 1, "name": "M\u00ednimo 9,5%", "slug": "9,5", "abbrev": "9,5%", "status": 1 }, { "id": 2, "name": "M\u00ednimo 10%", "slug": "10", "abbrev": "10%", "status": 1 }, { "id": 3, "name": "M\u00ednimo 10,5%", "slug": "10,5", "abbrev": "10,5%", "status": 1 }, { "id": 4, "name": "M\u00ednimo 11%", "slug": "11", "abbrev": "11%", "status": 1 }, { "id": 5, "name": "M\u00ednimo 11,5%", "slug": "11,5", "abbrev": "11,5%", "status": 1 }, { "id": 6, "name": "M\u00ednimo 12%", "slug": "12", "abbrev": "12%", "status": 1 }, { "id": 7, "name": "M\u00ednimo 12,5%", "slug": "12,5", "abbrev": "12,5%", "status": 1 }] }, "condition": { "name": "Condici\u00f3n", "empty": null, "order": 1, "abbrev": "Cond.", "status": 1, "values": [{ "id": 1, "name": "C\u00e1mara", "slug": "camara", "abbrev": "Cam.", "status": 1 }, { "id": 2, "name": "No C\u00e1mara", "slug": "no_camara", "abbrev": "No Cam.", "status": 1 }] } }, "order_quantity_label": { "venta": "Cantidad", "compra": "Cantidad" } }, "contract_clauses": null, "active": 1, "quantity_units": [{ "id": 1, "name": "Tonelada m\u00e9trica", "name_plural": "Tonelada(s)", "abbrev": "t", "slug": "t" }] }, { "id": 4, "name": "Girasol", "buyer": false, "seller": false, "attributes": { "harvest": { "enabled": true }, "quality": { "condition": { "name": "Condici\u00f3n", "empty": null, "order": 1, "abbrev": "Cond.", "status": 1, "values": [{ "id": 1, "name": "F\u00e1brica", "slug": "fabrica", "abbrev": "Fab.", "status": 1 }, { "id": 2, "name": "C\u00e1mara", "slug": "camara", "abbrev": "Cam.", "status": 1 }] } }, "order_quantity_label": { "venta": "Cantidad", "compra": "Cantidad" } }, "contract_clauses": null, "active": 1, "quantity_units": [{ "id": 1, "name": "Tonelada m\u00e9trica", "name_plural": "Tonelada(s)", "abbrev": "t", "slug": "t" }] }, { "id": 5, "name": "Sorgo", "buyer": false, "seller": false, "attributes": { "harvest": { "enabled": true }, "quality": { "color": { "name": "Color", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 3, "abbrev": "", "status": 1, "values": [{ "id": 1, "name": "Colorado", "slug": "colorado", "abbrev": "Colorado", "status": 1 }, { "id": 2, "name": "Blanco", "slug": "blanco", "abbrev": "Blanco", "status": 1 }] }, "grade": { "name": "Grado", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 2, "abbrev": "GR", "status": 1, "values": [{ "id": 1, "name": "1", "slug": "1", "abbrev": "1", "status": 1 }, { "id": 2, "name": "2", "slug": "2", "abbrev": "2", "status": 1 }, { "id": 3, "name": "3", "slug": "3", "abbrev": "3", "status": 1 }] }, "taninos": { "name": "Taninos", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 4, "abbrev": "", "status": 1, "values": [{ "id": 1, "name": "Bajo Tanino", "slug": "bajo-tanino", "abbrev": "Bajo Tanino", "status": 1 }] }, "condition": { "name": "Condici\u00f3n", "empty": null, "order": 1, "abbrev": "Cond.", "status": 1, "values": [{ "id": 1, "name": "C\u00e1mara", "slug": "camara", "abbrev": "Cam.", "status": 1 }] } }, "order_quantity_label": { "venta": "Cantidad", "compra": "Cantidad" } }, "contract_clauses": null, "active": 1, "quantity_units": [{ "id": 1, "name": "Tonelada m\u00e9trica", "name_plural": "Tonelada(s)", "abbrev": "t", "slug": "t" }] }, { "id": 6, "name": "Cebada Cervecera", "buyer": false, "seller": false, "attributes": { "harvest": { "enabled": true }, "quality": { "power": { "name": "Poder Germinativo", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 3, "abbrev": "PG", "status": 1, "values": [{ "id": 1, "name": "Menor o igual a 95", "slug": "menor_igual_95", "abbrev": "=<95", "status": 1 }, { "id": 2, "name": "98", "slug": "98", "abbrev": "98", "status": 1 }] }, "caliber": { "name": "Calibre", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 1, "abbrev": "Cal.", "status": 1, "values": [{ "id": 1, "name": "Menor a 80", "slug": "<80", "abbrev": "<80", "status": 1 }, { "id": 2, "name": "80", "slug": "80", "abbrev": "80", "status": 1 }, { "id": 3, "name": "85", "slug": "85", "abbrev": "85", "status": 1 }, { "id": 4, "name": "Mayor a 85", "slug": ">85", "abbrev": ">85", "status": 1 }] }, "protein": { "name": "Prote\u00edna bruta", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 2, "abbrev": "PB", "status": 1, "values": [{ "id": 1, "name": "Menor a 9,5", "slug": "<9,5", "abbrev": "<9,5", "status": 1 }, { "id": 2, "name": "Entre 9,5 y 13", "slug": "9,5to13", "abbrev": "9,5 a 13", "status": 1 }, { "id": 3, "name": "Mayor a 13", "slug": ">13", "abbrev": ">13", "status": 1 }] }, "variety": { "name": "Variedad", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 4, "abbrev": "", "status": 1, "values": [{ "id": 1, "name": "Aliciana", "slug": "aliciana", "abbrev": "Aliciana", "status": 1 }, { "id": 2, "name": "Andreia", "slug": "andreia", "abbrev": "Andreia", "status": 1 }, { "id": 3, "name": "Danielle", "slug": "danielle", "abbrev": "Danielle", "status": 1 }, { "id": 4, "name": "Jennifer", "slug": "jennifer", "abbrev": "Jennifer", "status": 1 }, { "id": 5, "name": "Scarlett", "slug": "scarlett", "abbrev": "Scarlett", "status": 1 }, { "id": 6, "name": "Shakira", "slug": "shakira", "abbrev": "Shakira", "status": 1 }, { "id": 7, "name": "Traveller", "slug": "traveller", "abbrev": "Traveller", "status": 1 }, { "id": 8, "name": "Overture", "slug": "overture", "abbrev": "Overture", "status": 1 }] } }, "order_quantity_label": { "venta": "Cantidad", "compra": "Cantidad" } }, "contract_clauses": null, "active": 1, "quantity_units": [{ "id": 1, "name": "Tonelada m\u00e9trica", "name_plural": "Tonelada(s)", "abbrev": "t", "slug": "t" }] }, { "id": 7, "name": "Cebada Forrajera", "buyer": true, "seller": true, "attributes": { "harvest": { "enabled": true }, "quality": { "PH": { "name": "PH", "empty": { "id": 0, "name": "No especifica", "slug": "no_especifica", "abbrev": "N\/A", "status": 1 }, "order": 2, "abbrev": "PH", "status": 1, "values": [{ "id": 1, "name": "M\u00ednimo 56", "slug": "56", "abbrev": "56", "status": 1 }, { "id": 2, "name": "M\u00ednimo 59", "slug": "59", "abbrev": "59", "status": 1 }, { "id": 3, "name": "M\u00ednimo 62", "slug": "62", "abbrev": "62", "status": 1 }] }, "quality": { "name": "Calidad", "empty": null, "order": 1, "abbrev": "Cal.", "status": 1, "values": [{ "id": 1, "name": "C\u00e1mara", "slug": "camara", "abbrev": "Cam.", "status": 1 }, { "id": 2, "name": "Fuera de Grado", "slug": "nogrado", "abbrev": "Fuera de Grado", "status": 1 }] } }, "order_quantity_label": { "venta": "Cantidad", "compra": "Cantidad" } }, "contract_clauses": null, "active": 1, "quantity_units": [{ "id": 1, "name": "Tonelada m\u00e9trica", "name_plural": "Tonelada(s)", "abbrev": "t", "slug": "t" }] }],
    zones: [{ "id": 1, "name": "Bah\u00eda Blanca", "locations": [{ "id": 3207, "name": "Ingeniero White" }, { "id": 3210, "name": "Puerto Galvan" }], "other": false }, { "id": 7, "name": "D\u00e1rsena", "locations": [{ "id": 3264, "name": "Avellaneda" }, { "id": 3255, "name": "Burzaco" }, { "id": 3283, "name": "Ca\u00f1uelas" }, { "id": 3311, "name": "General Rodriguez" }, { "id": 3337, "name": "Isidro Casanova" }, { "id": 3362, "name": "La Plata" }, { "id": 3377, "name": "Lujan" }, { "id": 1975, "name": "Open Door" }, { "id": 3406, "name": "Pilar" }, { "id": 3307, "name": "San Justo" }], "other": false }, { "id": 2, "name": "Lima \/ Z\u00e1rate \/ Del Guaz\u00fa", "locations": [{ "id": 2539, "name": "Las Palmas" }, { "id": 2540, "name": "Lima" }, { "id": 8947, "name": "Villa Paranacito" }], "other": false }, { "id": 3, "name": "Necochea", "locations": [{ "id": 3250, "name": "Quequen" }], "other": false }, { "id": 4, "name": "Rosario Norte", "locations": [{ "id": 16732, "name": "Puerto Gral San Martin" }, { "id": 16733, "name": "Puerto San Lorenzo" }, { "id": 16734, "name": "Ricardone" }, { "id": 16737, "name": "Timbues" }], "other": false }, { "id": 5, "name": "Rosario Sur", "locations": [{ "id": 16748, "name": "Alvear" }, { "id": 16750, "name": "Arroyo Seco" }, { "id": 16757, "name": "General Lagos" }, { "id": 16763, "name": "Rosario" }, { "id": 16767, "name": "Villa Gobernador Galvez" }], "other": false }, { "id": 6, "name": "V. Constituci\u00f3n \/ San Nicol\u00e1s \/ Ramallo", "locations": [{ "id": 2748, "name": "Ramallo" }, { "id": 2832, "name": "San Nicolas" }, { "id": 16744, "name": "Villa Constitucion" }], "other": false }]
  };

  constructor(
    private companyService: CompanyService,
    private componentComm: ComponentCommService,
    private currentDate: CurrentDateService,
    private modalService: BsModalService,
    private router: Router,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang === 'es' ? undefined : this.translateService.currentLang;

    this.componentComm.emit({ name: 'app-title', title: 'COMPANY.MARKET_PRICES' });

    this.subscriptions.push(this.companyService.watch().subscribe(company => {
      if (!company) return;

      this.company = company;

      // Kick user if module is not enabled
      if (!this.company.hasModule('market-prices')) this.router.navigateByUrl('/companies');
    }));

    this.subscriptions.push(this.modalService.onShown.subscribe((reason: string) => {
      if (this.inputCoord) {
        setTimeout((scope) => {
          document.getElementById(scope.inputCoord).focus();
        }, 10, this);
      }
    }));

    this.generatePeriods();
    this.loadData();
  }

  private loadData(): void {
    setTimeout((scope) => {
      // Random data generator
      let onlyUnique = function (value, index, self) {
        return self.indexOf(value) === index;
      },
        rndInt = function (min, max) { // min and max included 
          return Math.floor(Math.random() * (max - min + 1) + min);
        },
        rndElements = function (data, min, max) {
          max = Math.min(max, data.length);

          let numItems = rndInt(min, max),
            itemsInd = [],
            response = [];
          for (let i = 0; i < numItems; i++) itemsInd[i] = rndInt(0, data.length - 1);

          itemsInd = itemsInd.filter(onlyUnique);

          for (let i = 0; i < itemsInd.length; i++) response[i] = data[itemsInd[i]];
          return response;
        },
        rndCompanies = function (): any[] {
          return rndElements(scope.data.companies, 3, 50);
        },
        rndProducts = function (): any[] {
          return rndElements(scope.data.products, 1, 4);
        },
        rndZones = function (): any[] {
          return rndElements(scope.data.zones, 1, 4);
        },
        rndPeriods = function (): any[] {
          const today = startOfDay(new Date()),
            month = today.getMonth(),
            periods = [];

          today.setDate(1);

          for (let i = 0; i < 12; i++) {
            today.setMonth(month + i);
            periods.push(new Date(today.getTime()));
          }

          return rndElements(periods, 1, 4);
        },
        rndData = function (): any[] {
          let companies = rndCompanies(),
            response = [];

          for (let i = 0; i < companies.length; i++) {
            // Company
            let products = rndProducts(),
              prodData = [];

            for (let j = 0; j < products.length; j++) {
              // Product
              let zones = rndZones(),
                zoneData = [];

              for (let k = 0; k < zones.length; k++) {
                // Periods
                let periods = rndPeriods(),
                  periData = [];

                for (let l = 0; l < periods.length; l++) {
                  periData.push({
                    date: periods[l],
                    price: {
                      unit: { id: 1, name: "AR$", slug: "ars" },
                      value: rndInt(12000, 17000)
                    }
                  })
                }

                zoneData.push({
                  zone: zones[k],
                  periods: periData
                })
              }

              prodData.push({
                product: products[j],
                delivery_places: zoneData
              });
            }

            response.push({
              company: companies[i],
              products: prodData
            })
          }

          return response;
        };

      this.dataLoaded(rndData());
      // this.dataLoaded([]);
    }, 500, this);
  }

  private generatePeriods(): void {
    let today = startOfDay(this.currentDate.get()),
      month = today.getMonth();

    this.market_periods = [];

    today.setDate(1);

    for (let i = 0; i < 12; i++) {
      today.setMonth(month + i);
      this.market_periods.push(new Date(today.getTime()));
    }
  }

  private dataLoaded(data): void {
    this.marketPrices = data;

    // Reset
    this.products = [];
    this.delivery_places = [];

    let onlyUniqueIdElements = function (array) {
      let result = [],
        map = new Map();

      for (let item of array) {
        if (!map.has(item.id)) {
          map.set(item.id, true);    // set any value to Map
          result.push(item);
        }
      }

      return result;
    };

    for (let i = 0; i < data.length; i++) {
      // Company
      let companyGroup = data[i];

      for (let j = 0; j < companyGroup.products.length; j++) {
        // Products
        let productGroup = companyGroup.products[j];

        productGroup.product.delivery_places = [];

        for (let k = 0; k < productGroup.delivery_places.length; k++) {
          // Delivery places
          let periodGroup = productGroup.delivery_places[k];

          if (periodGroup.zone) productGroup.product.delivery_places.push({
            zone: periodGroup.zone,
            id: 'z_' + periodGroup.zone.id // Id hack to get uniques
          });
          if (periodGroup.location) productGroup.product.delivery_places.push({
            location: periodGroup.location,
            id: 'l_' + periodGroup.location.id // Id hack to get uniques
          });

          productGroup.product.delivery_places = onlyUniqueIdElements(productGroup.product.delivery_places);
        }

        this.products.push(productGroup.product);
      }
    }

    this.products = onlyUniqueIdElements(this.products);

    this.renderData(data);
    this.loading = false;
  }

  private renderData(data): void {
    this.tableMatrix = {};

    // Go through data
    data.forEach(companyData => {
      // Company
      companyData.products.forEach(productData => {
        // Product
        const p_id = productData.product.id;

        productData.delivery_places.forEach(placeData => {
          // Delivery places
          const l_id = (placeData.zone) ? 'z_' + placeData.zone.id : 'z_' + placeData.location.id;

          placeData.periods.forEach(periodData => {
            // Periods
            const periodId = String(periodData.date.getMonth() + 1) + periodData.date.getFullYear();

            if (!this.tableMatrix[p_id]) this.tableMatrix[p_id] = {};
            if (!this.tableMatrix[p_id][l_id]) this.tableMatrix[p_id][l_id] = {};
            if (!this.tableMatrix[p_id][l_id][periodId]) this.tableMatrix[p_id][l_id][periodId] = [];

            this.tableMatrix[p_id][l_id][periodId].push({
              company: companyData.company,
              product: productData.product,
              zone: placeData.zone,
              location: placeData.location,
              price: periodData.price
            });
          });
        });
      });
    });
  }

  public getCompanyColor(id): any {
    if (this.c_colors[id] == undefined) {
      this.c_colors[id] = this.palette[this.currentColor++];
      if (this.currentColor >= this.palette.length) this.currentColor = 0;
    }

    return this.c_colors[id];
  }

  public editPrices(template: TemplateRef<any>, company_id?, product_id?, coord?): void {
    if (!this.processing) {
      if (coord) {
        this.inputCoord = 'p_' + coord.location + coord.date;
      } else this.inputCoord = null;

      // Reset
      this.editingData = {
        company: null,
        product: null,
        locations: {}
      };

      this.data.zones.forEach(zone => {
        this.editingData.locations['z_' + zone.id] = {};
      });

      if (company_id != undefined) {
        for (let i = 0; i < this.data.companies.length; i++) {
          if (this.data.companies[i].id === company_id) {
            this.editingData.company = this.data.companies[i];
            break;
          }
        }

        if (product_id != undefined) {
          for (let i = 0; i < this.data.products.length; i++) {
            if (this.data.products[i].id === product_id) {
              this.editingData.product = this.data.products[i];
              break;
            }
          }

          this.switchPrices();
        }
      }

      // this.selectedGroup = group;
      this.openModal(template, 'modal-lg');
      // this.openModal(template);
    }
  }

  public switchPrices(): void {
    if (this.editingData.company && this.editingData.product) {
      const company_id = this.editingData.company.id;
      const product_id = this.editingData.product.id;

      this.data.zones.forEach(zone => {
        this.editingData.locations['z_' + zone.id] = {};
      });

      // Check for current data
      for (let i = 0; i < this.marketPrices.length; i++) {
        if (this.marketPrices[i].company.id === company_id) {
          let prods = this.marketPrices[i].products;

          for (let j = 0; j < prods.length; j++) {
            if (prods[j].product.id === product_id) {
              const delivery_places = prods[j].delivery_places;

              delivery_places.forEach(place => {
                place.periods.forEach(period => {
                  this.editingData.locations['z_' + place.zone.id][(period.date.getMonth() + 1).toString() + period.date.getFullYear()] = period.price.value;
                });
              });

              break;
            }
          }
          break;
        }
      }
    }
  }

  public savePrices(): void {
    this.processing = true;

    // Find company data
    let companyIndex = -1;
    for (let i = 0; i < this.marketPrices.length; i++) {
      if (this.marketPrices[i].company.id === this.editingData.company.id) {
        companyIndex = i;
        break;
      }
    }
    if (companyIndex < 0) companyIndex = this.marketPrices.push({
      company: this.editingData.company,
      products: []
    }) - 1;

    let companyData = this.marketPrices[companyIndex];

    // Find product data
    let productIndex = -1;
    for (let i = 0; i < companyData.products.length; i++) {
      if (companyData.products[i].product.id === this.editingData.product.id) {
        productIndex = i;
        break;
      }
    }
    if (productIndex < 0) productIndex = companyData.products.push({
      product: this.editingData.product
    }) - 1;

    let productData = this.marketPrices[companyIndex].products[productIndex];

    // Reset delivery_places data
    productData.delivery_places = [];

    // Delivery places and prices
    for (let i in this.editingData.locations) {
      let location = this.editingData.locations[i];

      // Get delivery places from i
      let place = this.getCompanyDeliveryPlace(i),
        placeData;

      // Periods
      for (let k in location) {
        if (location[k] > 0) {
          if (!placeData) {
            placeData = productData.delivery_places[productData.delivery_places.push({
              zone: place, // Hardcoded zone, add location support
              periods: []
            }) - 1];
          }

          let date = this.getDateFromRef(k);

          placeData.periods.push({
            date: date,
            price: {
              unit: { id: 1, name: "AR$", slug: "ars" },
              value: location[k]
            }
          });
        }
      }
    }

    this.dataLoaded(this.marketPrices);

    // Emulates an API request
    setTimeout((scope) => {
      scope.modalRef.hide();
      scope.processing = false;
    }, 500, this);
  }

  private getCompanyDeliveryPlace(location_id: string): any {
    const id = location_id.substring(2);

    if (location_id.startsWith('z_')) {
      // Zone
      for (let i = 0; i < this.data.zones.length; i++) {
        if (id === this.data.zones[i].id.toString()) return this.data.zones[i];
      }
    } else {
      // Locations
    }
  }

  private getDateFromRef(date_ref: string): Date {
    // Reverse for (date.getMonth() + 1)+''+date.getFullYear()
    const year = parseInt(date_ref.substring(-4)),
      month = parseInt(date_ref.slice(0, -4)) - 1;

    return new Date(year, month, 1);
  }

  /** Generic Modal trigger. */
  private openModal(template: TemplateRef<any>, c: string = ''): void {
    this.modalRef = this.modalService.show(template, { class: c });

    // this.modalSub = this.modalRef.onHide.subscribe((reason: string) => {
    //   this.modalSub.unsubscribe();
    //   this.modalRef = undefined;
    //   // Reset all values
    //   this.processing = false;
    // });
  }

  /** Closes the most recent opened modal. */
  public closeModal(onHide: Function = null): void {
    if (this.modalRef) {
      this.modalRef.hide();
      if (onHide) this.modalRef.onHide.subscribe(onHide);
    } else {
      if (onHide) onHide();
    }
  }

  /** @ignore */
  ngOnDestroy(): void {
    this.closeModal();

    // Unsubscribe from everything
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
